import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../config/app-config';

/**
 * Adds the current access token to the `Authorization` header for outgoing
 * requests. Only applies header to requests sent to URLs indicated by app config.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    static readonly AUTH_HEADER_NAME = 'Authorization';
    private readonly oktaAuth: OktaAuth = inject(OKTA_AUTH);
    private readonly appConfig: AppConfig = inject(APP_CONFIG);

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Only add an access token to whitelisted URLS
        const allowedOrigins: string[] = this.appConfig.authenticatedEndpoints;
        if (allowedOrigins.some((url) => request.url.includes(url))) {
            const accessToken = this.oktaAuth.getAccessToken();

            if (accessToken) {
                request = request.clone({
                    setHeaders: {
                        [AuthInterceptor.AUTH_HEADER_NAME]: `Bearer ${accessToken}`,
                    },
                });
            }
        }
        return next.handle(request);
    }
}
